import { render, staticRenderFns } from "./orgpersonnel.vue?vue&type=template&id=1f7691d4&"
import script from "./orgpersonnel.vue?vue&type=script&lang=js&"
export * from "./orgpersonnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports